import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function AccountPostalCodeField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    setError(false);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Zip/Postal Code'
          id='postal_code'
          aria-describedby='postal-code-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          variant='standard'
        />
        {error ? (
          <FormHelperText id='postal-code-helper-text'>{error}</FormHelperText>
        ) : undefined}
      </FormControl>
    </Box>
  );
}
